"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.IWatch=void 0;class IWatch{}exports.IWatch=IWatch;